import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UseraccessserviceService } from 'src/app/services/useraccessservice.service';

@Component({
  selector: 'app-externalauth',
  templateUrl: './externalauth.component.html',
  styleUrls: ['./externalauth.component.css']
})
export class ExternalauthComponent implements OnInit {
  islecturer: any;
  constructor(private activatedroute: ActivatedRoute, private userservice: UseraccessserviceService, private router: Router) { }

  ngOnInit(): void {
    const jwt = this.activatedroute.snapshot.queryParams.jwt;
    this.userservice.setAuthenticatedUserToken(jwt);
    this.islecturer = this.activatedroute.snapshot.queryParams.lecturer;
    debugger
    if (this.islecturer === "true") {
      this.router.navigate(['/user/usermodules']);
    }
    else
      this.router.navigate(['/']);
  }

}
